import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  /* height: calc(100vh - var(--nav-bar-height)); */
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 1rem 0;
`;
export const TabSection = styled.div`
  padding: 2rem;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
`;
